import React, { FC, ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
  parentClassName?: string;
  bg?: string;
}

const Card: FC<CardProps> = ({ children, className, parentClassName = "", bg = "bg-white" }) => {
  return (
    <div className={`flex w-full ${bg} rounded-xl md:rounded-2xl border-[1px] border-[#E4E6F2] shadow-xl ${parentClassName}`}>
      <div className={`${className}`}>{children}</div>
    </div>
  );
};

export default Card;
